import { CUSTOM_TRANSPORT_PRODUCT_TYPES_SCHEMA, PRODUCT_TYPES } from '@schuettflix/interfaces';

export function isTransportProduct(product: { type: PRODUCT_TYPES }) {
    return CUSTOM_TRANSPORT_PRODUCT_TYPES_SCHEMA.safeParse(product.type).success;
}
